import { type UntypedLibrary } from '@/types/utils';

/**
 * Create a validator for validating an enum-like const object prop type.
 *
 * @example
 * ```ts
 * export const UserAvatarsSizes = {
 *   Small: 'small',
 *   Medium: 'medium',
 * } as const;
 *
 * // In a Vue component
 * props: {
 *   size: {
 *     type: String as PropType<ValueOf<typeof UserAvatarsSizes>>,
 *     validator: isValueOf(UserAvatarsSizes),
 *   },
 * }
 * ```
 */
export const isValueOf =
	(constObject: Record<string, string>) => (val: unknown) => {
		// Vue validator function argument is of type `unknown` which does not
		// match the values of the const object
		return Object.values(constObject).includes(val as UntypedLibrary);
	};

/* Create a validator for validating positive string type numbers */
export const isStringNumberBiggerThanZero = () => (val: string) => {
	return parseInt(val) > 0 && !isNaN(parseInt(val));
};
